const USE_CASE_BASE_PATH = '/use-cases/';
const EVENTS_BASE_PATH = '/events/';

module.exports = {
  USE_CASE_BASE_PATH,
  EVENTS_BASE_PATH,
};
